/* eslint-disable react/prop-types */
import React from 'react';
import SecondaryFooter from '../../site/components/second-footer';
import {stackupFooterPresenter} from '../utils';
import {SigninDesktopModal} from '../../../shared/library/modals/signin';
import {GO_BACK} from '../../../shared/enhancers/router-enhancer';
import Advice from '../components/modal/advice';

const EndComponents = ({
  stackup,
  signin,
  setSignupAction,
  signupAction,
  slug,
  openAdviceModal,
  tools,
  setOpenAdviceModal,
  toolsLoaded
}) => {
  return (
    <>
      {stackup && <SecondaryFooter sections={stackupFooterPresenter(stackup)} />}
      {signin && (
        <SigninDesktopModal
          onDismiss={() => {
            setSignupAction(null);
            GO_BACK();
          }}
          redirect={signupAction ? `/stackups/${slug}/!/${signupAction}` : `/stackups/${slug}`}
        />
      )}
      {toolsLoaded && stackup && openAdviceModal && (
        <Advice
          tools={tools.filter(tool => tool.name)}
          onDismiss={() => setOpenAdviceModal(false)}
          title={`Ask the StackShare community about ${stackup.title} (Beta)!`}
        />
      )}
    </>
  );
};

export default EndComponents;
